/** Default title persisted when creating a document from + New document. */
export const UNTITLED_DOCUMENT_TITLE = 'Untitled document';

/** Default name persisted when creating a work item from + New work item. */
export const UNTITLED_WORK_ITEM_TITLE = 'Untitled work item';
